<template>
    <v-dialog width="240" v-model="mostra">
        <template v-for="(_, name) in $scopedSlots" #[name]="slotProps = {}">
            <slot v-bind="slotProps" :name="name" />
        </template>
        <v-card>
            <v-list-item>
                <v-list-item-title class="text-h5">
                    Convidados
                </v-list-item-title>
            </v-list-item>
            <v-list>
                <v-list-item v-for="opcao in opcoes" :key="opcao.chave">
                    <v-list-item-title>
                        {{ convidados[opcao.chave] }} {{ opcao.descricao }}
                    </v-list-item-title>
                    <v-list-item-icon>
                        <v-icon
                            :disabled="convidados[opcao.chave] < 1"
                            color="error"
                            @click="() => --convidados[opcao.chave]"
                        >mdi-minus</v-icon>
                    </v-list-item-icon>
                    <v-list-item-icon>
                        <v-icon
                            color="success"
                            @click="() => ++convidados[opcao.chave]"
                        >mdi-plus</v-icon>
                    </v-list-item-icon>
                </v-list-item>
            </v-list>
            <v-card-actions>
                <v-btn
                    @click="mostra = false" text
                    :disabled="salvando"
                > Cancelar </v-btn>
                <v-btn
                    color="primary"
                    outlined
                    class="ml-auto"
                    @click="salvarConvidados"
                    :disabled="salvando"
                    :loading="salvando"
                > Salvar </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script setup lang="ts">
import { useMutation } from '@tanstack/vue-query';
import { Convidados, IPresenca } from 'common/types/Presenca';
import { TIPOS_DE_CONVIDADOS } from '@/../common/shareds/sharedPresenca';
import { defineComponent, ref, watch } from 'vue';
import PresencaService from '@/services/PresencaService';

defineComponent({})

const props = defineProps<{ value: IPresenca }>()
const emit = defineEmits(['input']);

const opcoes = TIPOS_DE_CONVIDADOS

const convidados = ref(criarConvidados())
const mostra = ref(false)

watch(mostra, (novo, antigo) => {
    if (novo && !antigo) convidados.value = criarConvidados(props.value)
})

const { mutate: salvarConvidados, isPending: salvando } = useMutation({
    mutationFn: () => PresencaService.patch(props.value._id, {
        convidados: convidados.value,
    }),
    onSuccess(presenca) {
        emit('input', presenca)
        mostra.value = false
    },
})

function criarConvidados(presenca?: IPresenca): Convidados {
    return presenca?.convidados 
        ? { ...presenca.convidados }
        : {
            adultos: 0,
            criancas: 0
        }
}
</script>